import { COLUMN_DISPLAY_NAME, COLUMN_FIRST_NAME, COLUMN_SECOND_NAME, COLUMN_LAST_NAME, COLUMN_COMPANY, COLUMN_DEPARTMENT, COLUMN_TITLE, COLUMN_UNIQUE_IDENTIFIER, COLUMN_SITE, COLUMN_DATE, COLUMN_DAYS, REPORTS_COLUMN_HOURS_WORKED, REPORTS_COLUMN_HOURS_WORKED_TO_NOW, COLUMN_PROFILE, COLUMN_CONTROLLER, COLUMN_ZONE, COLUMN_BUILDING, COLUMN_FLOOR, COLUMN_READER } from "../../constants/column-types";
import { FILTER_COMPANIES, FILTER_DEPARTMENTS, FILTER_SITES, FILTER_PROFILE, FILTER_DATE, FILTER_CONTROLLER, FILTER_ZONES, FILTER_BUILDINGS, FILTER_FLOORS, FILTER_READERS } from "../../constants/filter-types";
import { TableColumn } from "../table/TableColumn";

const HoursWorkedReportColumn: TableColumn[] = [
    {
        heading: "Title",
        accessor: "title",
        isNumeric: false,
        id: 0,
        active: false,
        translationKey: "title",
        columnId: COLUMN_TITLE,
    },
    {
        heading: "Display Name",
        accessor: "displayName",
        sortDirection: "asc",
        sortByName: "mstDisplayname",
        isNumeric: false,
        id: 1,
        active: true,
        translationKey: "displayName",
        isDefault: true,
        columnId: COLUMN_DISPLAY_NAME
    },
    {
        heading: "First Name",
        accessor: "firstName",
        isNumeric: false,
        id: 2,
        sortByName: "mstFirstname",
        sortDirection: "asc",
        active: false,
        translationKey: "firstName",
        columnId: COLUMN_FIRST_NAME
    },
    {
        heading: "Second Name",
        accessor: "middleName",
        isNumeric: false,
        id: 3,
        sortByName: "mstMiddlename",
        sortDirection: "asc",
        active: false,
        translationKey: "secondName",
        columnId: COLUMN_SECOND_NAME
    },
    {
        heading: "Last Name",
        accessor: "lastName",
        isNumeric: false,
        id: 4,
        sortByName: "mstLastname",
        sortDirection: "asc",
        active: false,
        translationKey: "lastName",
        columnId: COLUMN_LAST_NAME
    },
    {
        heading: "Unique Identifier",
        accessor: "idNumber",
        isNumeric: false,
        id: 5,
        active: false,
        translationKey: "uniqueIdentifier",
        columnId: COLUMN_UNIQUE_IDENTIFIER,
    },
    {
        heading: "Date",
        accessor: "dateOnly",
        isNumeric: false,
        id: 6,
        searchOnName: "dateOnly",
        sortByName: "dateOnly",
        active: true,
        translationKey: "dateOnly",
        columnId: COLUMN_DATE,
        filterId: FILTER_DATE,
        settingDataName: "date",
        hideLookup: true
    },
    {
        heading: "Day of week",
        accessor: "dayOfWeek",
        isNumeric: false,
        id: 7,
        active: true,
        translationKey: "dayOfWeek",
        isDefault: true,
        columnId: COLUMN_DAYS
    },
    {
        heading: "Hours Worked",
        accessor: "hoursWorked",
        isNumeric: false,
        id: 8,
        active: true,
        isDefault: true,
        translationKey: "hoursWorked",
        columnId: REPORTS_COLUMN_HOURS_WORKED
    },
    {
        heading: "Hours Worked (to now)",
        accessor: "hoursWorkedNow",
        isNumeric: false,
        id: 9,
        active: true,
        isDefault: true,
        translationKey: "hoursWorkedTillNow",
        columnId: REPORTS_COLUMN_HOURS_WORKED_TO_NOW
    },
    {
        heading: "Company",
        accessor: "company",
        isNumeric: false,
        id: 10,
        // sortByName: "company.compName", // Do not allow sorting on relationships. Elide can't do sort and filter on these well.
        searchOnName: "company.id",
        lookupName: "company.id",
        active: false,
        translationKey: "company",
        columnId: COLUMN_COMPANY,
        filterId: FILTER_COMPANIES,
        settingDataName: 'company'
    },
    {
        heading: "Department",
        accessor: "department",
        isNumeric: false,
        id: 11,
        // sortByName: "department.deptName", // Do not allow sorting on relationships. Elide can't do sort and filter on these well.
        active: true,
        searchOnName: "department.id",
        lookupName: "department.id",
        translationKey: "department",
        columnId: COLUMN_DEPARTMENT,
        filterId: FILTER_DEPARTMENTS,
        settingDataName: 'department'
    },
    {
        heading: "Category",
        accessor: "category",
        isNumeric: false,
        id: 12,
        searchOnName: "profile.id",
        lookupName: "profile.id",
        active: false,
        translationKey: "category",
        columnId: COLUMN_PROFILE,
        filterId: FILTER_PROFILE,
        settingDataName: 'profile'
    },
    {
        heading: "Site",
        accessor: "site",
        isNumeric: false,
        id: 13,
        searchOnName: "site.id",
        lookupName: "site.id",
        active: true,
        translationKey: "site",
        columnId: COLUMN_SITE,
        filterId: FILTER_SITES,
        settingDataName: 'site'
    },

    // Only used for the filter modal
    {
        id: 14,
        heading: "Controller",
        accessor: "controller",
        isNumeric: false,
        searchOnName: "transacksForTrMasterId.controller.id",
        lookupName: "transacksForTrMasterId.controller.id",
        active: false,
        translationKey: "controller",
        columnId: COLUMN_CONTROLLER,
        filterId: FILTER_CONTROLLER,
        settingDataName: 'deviceImprox',
        isFilterOnlyColumn: true
    },
    {
        id: 14,
        heading: "Zone",
        accessor: "zone",
        isNumeric: false,
        searchOnName: "transacksForTrMasterId.zone.id",
        lookupName: "transacksForTrMasterId.zone.id",
        active: false,
        translationKey: "zone",
        columnId: COLUMN_ZONE,
        filterId: FILTER_ZONES,
        settingDataName: 'zone',
        isFilterOnlyColumn: true
    },
    {
        id: 15,
        heading: "Building",
        accessor: "building",
        isNumeric: false,
        searchOnName: "transacksForTrMasterId.building.id",
        lookupName: "transacksForTrMasterId.building.id",
        active: false,
        translationKey: "building",
        columnId: COLUMN_BUILDING,
        filterId: FILTER_BUILDINGS,
        settingDataName: 'building',
        isFilterOnlyColumn: true
    },
    {
        id: 16,
        heading: "Floor",
        accessor: "floor",
        isNumeric: false,
        searchOnName: "transacksForTrMasterId.floor.id",
        lookupName: "transacksForTrMasterId.floor.id",
        active: false,
        translationKey: "floor",
        columnId: COLUMN_FLOOR,
        filterId: FILTER_FLOORS,
        settingDataName: 'floor',
        isFilterOnlyColumn: true
    },
    {
        id: 17,
        heading: "Reader",
        accessor: "reader",
        isNumeric: false,
        searchOnName: "transacksForTrMasterId.terminal.id",
        lookupName: "transacksForTrMasterId.terminal.id",
        active: false,
        translationKey: "reader",
        columnId: COLUMN_READER,
        filterId: FILTER_READERS,
        settingDataName: 'deviceImprox',
        isFilterOnlyColumn: true
    }
]

export default HoursWorkedReportColumn;
